import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-html-video-example',
  templateUrl: './html-video-example.component.html',
  styleUrls: ['./html-video-example.component.scss']
})
export class HtmlVideoExampleComponent implements OnInit {
  @ViewChild('videoElement', { static: true }) _videoElement: any;
  @ViewChild('PauseButton', { static: true }) _PauseButtonElement: any;

  _PlayingStatus = '';
  _Video: any;
  _PauseButton: any;
  constructor() { }

  ngOnInit() {
    this._PlayingStatus = 'Playing...';
    this._Video = this._videoElement.nativeElement;
    this._Video.addEventListener('ended', this.videoEnded);
    this._Video.addEventListener('touchstart', this.videoPlay);
    this._PauseButton = this._PauseButtonElement.nativeElement;
  }

  PauseToggle(e) {
    // e.preventDefault();
    // e.getPreventDefault();
    this._Video.classList.toggle('stopfade');
    if (this._Video.paused) {

      this. _Video.play();
        this._PauseButton.innerHTML = 'Pause';
        this._PlayingStatus = '(Playing)';
    } else {

      this._Video.pause(); this._PauseButton.innerHTML = 'Play';
      this._PlayingStatus = '(Paused)';
    }
}

videoPlay(e) {
    e.preventDefault();
    this._Video.play();
}
videoFade() {
    this._Video.classList.add('stopfade');
}
videoEnded() {
    this._Video.pause();
    this.videoFade();
}


  /*
              var vid = document.getElementById("bgvid")
                , pauseButton = document.querySelector("#textDiv button");
ng 
            function vidFade() {
                vid.classList.add("stopfade");
            }
            vid.addEventListener('ended', function () {

                vid.pause(); vidFade();
                //alert('Video Ended!');
            }, false);

            function PauseToggle() {
                //event.preventDefault();
                //event.getPreventDefault();
                vid.classList.toggle("stopfade");
                if (vid.paused) {

                    vid.play();
                    pauseButton.innerHTML = "Pause";
                    //alert('Playing!');
                } else {

                    vid.pause(); pauseButton.innerHTML = "Play";
                    //alert('Paused!');
                }
            }
            //pauseButton.addEventListener("click", function () {
            //    event.preventDefault();
            //    event.getPreventDefault();
            //    vid.classList.toggle("stopfade");
            //    if (vid.paused) {

            //        vid.play();
            //        pauseButton.innerHTML = "Pause";
            //        //alert('Playing!');
            //    } else {

            //        vid.pause(); pauseButton.innerHTML = "Play";
            //        //alert('Paused!');
            //    }
            //}, false);

            vid.addEventListener('touchstart', function (e) {
                //alert('TouchStart!');
                e.preventDefault();
                vid.play();
            })
  */
}
